module.exports = __webpack_public_path__ + "static/media/gameDiseasedTrees.c33eb803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameDiseasedTrees.png
// module id = 911
// module chunks = 0